exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".loader {\n  border: 2px solid #f3f3f3;\n  border-top: 2px solid #20a8d8;\n  border-radius: 50%;\n  width: 17px;\n  height: 17px;\n  animation: spin 1s linear infinite; }\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n\n.actions button span {\n  display: none; }\n\n.actions .showText {\n  display: inline !important; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/views/dashboards/dashboard-filter/dashboard-filter.component.scss
// module id = ../../../../../src/app/views/dashboards/dashboard-filter/dashboard-filter.component.scss
// module chunks = main